import { Props as BaseProps, InstancesTableController } from '../../../common/instances/controllers/InstancesTableController';
import { Instance } from '../../../common/instances/models/Instance';
import { BLANK_PAGINATION_RESULT, CursorInfo, PaginationResult } from '../../../common/types/pagination';
import { DEFAULT_OPERATION_INSTANCES_PAGE_SIZE, OperationRepository } from '../services/OperationRepository';

type Props = BaseProps & {
  operationId: number;
};

export class OperationInstancesTable extends InstancesTableController<Props> {
  private readonly repository = new OperationRepository();

  componentWillUnmount(): void {
    super.componentWillUnmount();

    this.repository.cancelAllRequests();
  }

  protected getDefaultPageSize(): number {
    return DEFAULT_OPERATION_INSTANCES_PAGE_SIZE;
  }

  protected async fetchData(cursorInfo: CursorInfo): Promise<PaginationResult<Instance>> {
    try {
      return await this.repository.getOperationInstances(this.props.operationId, cursorInfo);
    } catch (e: unknown) {
      this.handleError(e);
      return BLANK_PAGINATION_RESULT;
    }
  }
}
